import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Icons} from '../../util/icons';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import Icon from '../icon';
import {Column, Row} from '../layout';
import * as fonts from '../../util/fonts';
import './styles.scss';
import {AuthConsumer} from '../../providers/AuthProvider';
import Button from '@mui/material/Button';
import LanguageIcon from '@mui/icons-material/Language';
import Stack from '@mui/material/Stack';

interface AppUserLogoutProps {
  user: any;
  labels: typeof strings.pt.start;
  globalStyles: any;
  setShowLanguageSelector(value: boolean): void;
  buDefaultFunctionalities: any;
}

function AppUserLogout({
  user,
  labels,
  globalStyles,
  setShowLanguageSelector,
  buDefaultFunctionalities,
}: AppUserLogoutProps) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLanguageActive, setIsLanguageActive] = useState(true);

  function getWindowWidth() {
    const {innerWidth: width, innerHeight: height} = window;
    setWindowWidth(width);
  }

  useEffect(() => {
    window.addEventListener('resize', getWindowWidth);
    return () => window.removeEventListener('resize', getWindowWidth);
  }, []);

  useEffect(() => {
    const multiLanguageActive = buDefaultFunctionalities?.funcionalidade?.find(
      (element: any) =>
        element?.featureTemplateAlias === functionalitiesAliasMap.multiLanguage
    )?.isVisible;
    setIsLanguageActive(multiLanguageActive);
  }, [buDefaultFunctionalities]);

  const handleDropdownShow = () => {
    if (showDropdown) {
      setShowDropdown(false);
    } else {
      setShowDropdown(true);
    }
  };

  return (
    <AuthConsumer>
      {({logout}) => (
        <div className="app-userlogout">
          <Stack direction="row" spacing={0}>
            <Column className="app-userlogout-content">
              {!showDropdown ? (
                <Row
                  className="app-userlogout-row-container"
                  onClick={handleDropdownShow}>
                  {/*remove comentted line when moods are ready */}
                  {/* <StepImage stepFill={colors.fluorescentBlue} /> */}
                  <Column className="logout-user-column">
                    <Row className="logout-user-row">
                      <p
                        className="logout-user-field"
                        style={{
                          ...fonts.M,
                          ...fonts.Medium,
                          color: globalStyles?.primaryColor,
                        }}>
                        {labels?.start_hello} {user.given_name}
                      </p>
                    </Row>
                    {/* <Row className="logout-user-row">
                    <p className="logout-user-field">Está em modo Gravidez</p>
                  </Row> */}
                  </Column>
                  <Column className="logout-user-column-dropdown">
                    <Icon
                      className="logout-user-input-icon"
                      color={globalStyles?.primaryColor}
                      name={Icons.CHEVRON_DOWN}
                      width={'22'}
                      height={'22'}
                      strokeWidth={'1'}
                      changeViewbox
                      viewBox={'0 0 24 24'}
                    />
                  </Column>
                </Row>
              ) : (
                <Column className="app-userlogout-dropdown-container">
                  <Row
                    className="app-userlogout-row-container"
                    onClick={handleDropdownShow}>
                    {/*remove comentted line when moods are ready */}
                    {/* <StepImage stepFill={colors.fluorescentBlue} /> */}
                    <Column className="logout-user-column">
                      <Row className="logout-user-row">
                        <p
                          className="logout-user-field"
                          style={{
                            ...fonts.M,
                            ...fonts.Medium,
                            color: globalStyles?.primaryColor,
                          }}>
                          {labels?.start_hello} {user.given_name}
                        </p>
                      </Row>
                      {/* <Row className="logout-user-row">
                      <p className="logout-user-field">Está em modo Gravidez</p>
                    </Row> */}
                    </Column>
                    <Column className="logout-user-column-dropdown">
                      <Icon
                        className="logout-user-input-icon-dropdown"
                        color={globalStyles?.primaryColor}
                        name={Icons.CHEVRON_DOWN}
                        width={'22'}
                        height={'22'}
                        strokeWidth={'1'}
                        changeViewbox
                        viewBox={'0 0 24 24'}
                      />
                    </Column>
                  </Row>
                  <Row
                    className="app-userlogout-end"
                    onClick={logout}
                    style={{cursor: 'pointer'}}>
                    <Row
                      className="app-userlogout-end-logout"
                      style={{...fonts.SM, ...fonts.Medium}}>
                      <Icon
                        className="logout-user-input-icon-dropdown-button"
                        color={globalStyles?.primaryColor}
                        name={Icons.LOG_OUT}
                        width={'19'}
                        height={'19'}
                        changeViewbox
                        viewBox={'0 0 24 24'}
                      />
                      {labels?.start_dropLogout}
                    </Row>
                  </Row>
                </Column>
              )}
            </Column>
            {isLanguageActive && (
              <Button
                className="app-userlogout-language-selector"
                onClick={() => setShowLanguageSelector(true)}
                sx={{
                  ...fonts.SM,
                  ...fonts.Medium,
                  marginTop: windowWidth > 768 ? '8%' : '2.4em',
                  color: globalStyles?.primaryColor,
                  alignSelf: 'baseline',
                }}
                startIcon={
                  <LanguageIcon sx={{color: globalStyles?.primaryColor}} />
                }>
                <span style={{fontSize: '17px'}}>
                  {user.language?.split('-')[0]}
                </span>
              </Button>
            )}
          </Stack>
        </div>
      )}
    </AuthConsumer>
  );
}

const mapStateToProps = ({
  user,
  strings,
  globalStyles,
  buDefaultFunctionalities,
}: any) => ({
  user: user.value,
  labels: strings.value.pt.start,
  globalStyles: globalStyles.value,
  buDefaultFunctionalities: buDefaultFunctionalities.value,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AppUserLogout
);
